export const CONDOMINIUM_TYPES = Object.freeze({
  NORMAL: 'Normal',
  NOT_INFORMED: 'NaoInformado',
  NOT_EXIST: 'NaoExiste',
  INCLUDED: 'IncluidoNoAluguel',
});

export default CONDOMINIUM_TYPES;
